import { Inject, Injectable } from '@angular/core';
import { TInputAppEnvironmentVars } from '@monorepo/types';

export const trimInspectionEndPoints = {
  TRIMS_LOT_LISTING: 'TRIMS_LOT_LISTING',
  AQL_LISTING: 'AQL_LISTING',
  START_OR_UPDATE_INSPECTION: 'START_OR_UPDATE_INSPECTION',
  SYNC_INSPECTION: 'SYNC_INSPECTION',
  COMPLETE_INSPECTION: 'COMPLETE_INSPECTION',
  RESTART_INSPECTION: 'RESTART_INSPECTION',
  GET_LOT_DETAILS: 'GET_LOT_DETAILS',
  GET_TRIMS_COUNT: 'GET_TRIMS_COUNT',
  GET_LOT_DETAILS_BY_GRNTAG: 'GET_LOT_DETAILS_BY_GRNTAG',
};

type TTrimInspectionEndPoints = typeof trimInspectionEndPoints;
type TTrimInspectionEndPointsTypes = keyof TTrimInspectionEndPoints;

@Injectable({
  providedIn: 'root',
})
export class TrimInspectionEnvService {
  public mode = 'dev';

  HOST_DOMAIN;
  HOST_DOMAIN_WITH_PROTOCOL;

  private env_vars: TTrimInspectionEndPoints = {
    TRIMS_LOT_LISTING: '',
    AQL_LISTING: '',
    GET_LOT_DETAILS: '',
    START_OR_UPDATE_INSPECTION: '',
    SYNC_INSPECTION: '',
    COMPLETE_INSPECTION: '',
    RESTART_INSPECTION: '',
    GET_TRIMS_COUNT: '',

    GET_LOT_DETAILS_BY_GRNTAG: '',
  };

  constructor(@Inject('environment') environment: TInputAppEnvironmentVars) {
    if (environment.mode) {
      this.mode = environment.mode;
    }

    this.HOST_DOMAIN = environment.service_host;
    this.HOST_DOMAIN_WITH_PROTOCOL = environment.protocol + this.HOST_DOMAIN;
    this.registerVars(environment);
  }

  private registerVars(environment: TInputAppEnvironmentVars) {
    this.env_vars.TRIMS_LOT_LISTING =
      this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/api/v1/wms/trimInspection/getLotListing';
    this.env_vars.AQL_LISTING = this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/api/v1/wms/getAQLLevels';
    this.env_vars.START_OR_UPDATE_INSPECTION =
      this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/api/v1/wms/trimInspection/startOrUpdateInspection';
    this.env_vars.SYNC_INSPECTION =
      this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/api/v1/wms/trimInspection/syncInspection';
    this.env_vars.COMPLETE_INSPECTION =
      this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/api/v1/wms/trimInspection/completeInspection';
    this.env_vars.RESTART_INSPECTION =
      this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/api/v1/wms/trimInspection/restartInspection';
    this.env_vars.GET_LOT_DETAILS =
      this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/api/v1/wms/trimInspection/getLotDetails';
    this.env_vars.GET_TRIMS_COUNT =
      this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/api/v1/wms/trimInspection/getTrimsCount';
    this.env_vars.GET_LOT_DETAILS_BY_GRNTAG =
      this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/api/v1/wms/trimInspection/grn/getLotDetails';
  }

  public getEnvVar(arg: TTrimInspectionEndPointsTypes): string {
    return this.env_vars[arg];
  }
}
